import React from "react";
import { Container } from "reactstrap";

const AssociationsHeader = (props) => (
  <Container>
    <h1>Faites connaître votre association et publiez vos activités</h1>
    {/* <Jumbotron id="box">
      <p className="lead">
        La démarche proposée concerne les activités récurrentes, au long de l’année, des associations du pays messin. Si
        vous organisez un événement ponctuel, utilisez <a href="/agenda/proposer/">le formulaire dédié à l’agenda</a>.
        Les activités en dehors du pays messin ou à caractère commercial ne pourront être prises en compte. Un email de
        confirmation vous sera envoyé à l’issue de la démarche
      </p>
    </Jumbotron>
    <br /> */}
  </Container>
);

export default AssociationsHeader;
